<template>
<div @keydown.esc='openModal'>
   <!-- div used because @click can't be added to slot -->
   <div @click="openModal" class="modal__open-button">
      <slot name="button" class="hello" :data-modal-id='id'></slot>
   </div>

   <div :id="id" :class="classes">
      <div @click='openModal' class="modal__overlay"></div>
      <div class="modal__body">
         <div class="modal__header">
            <div class="modal__title">{{heading}}</div>
            <button @click='openModal' class="modal__close--button"></button>
         </div>
         <div class="modal__content">
            <slot name="body"></slot>
         </div>
      </div>
   </div>
</div>
</template>

<script>
export default {
   data() {
      return {
         open: false
      }
   },
   props: {
      id: {type: String, default: null},
      heading: {type: String, default: null},
   },
   methods: {
      openModal(e) {
         e.type == 'keydown' ? this.open = false : this.open = !this.open
      }
   },
   computed: {
      classes () {
         const { open } = this

         return [
            'modal',
            open ? 'open' : null
         ]
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/modal.scss';
</style>